import React from 'react'

const OptionTab = (props) => {
    const agent = props.agent
    const handleChange = (e, agentId) => {
        props.onChange(e, agentId)
    }

    return (
        <div className='flex items-center overflow-hidden rounded-[10px] border border-border'>
            <label htmlFor="commission_detail" className='flex-1 cursor-pointer'>
                <input onChange={ e => handleChange(e, agent?._id) } type="radio" name="commission_payout_detail" id="commission_detail" value='commission' className='hidden peer' />
                <div className='peer-checked:bg-black peer-checked:text-white transition duration-300 bg-white text-gray-two flex-1 flex text-center justify-center items-center md:p-3.5 p-2 md:text-base text-sm'>Commission</div>
            </label>

            {
                ((props.allowToSeePayout) || (props.agent?._id === props.fromAgentId)) &&
                <label htmlFor="payout_detail" className='flex-1 cursor-pointer'>
                    <input onChange={ e => handleChange(e, agent?._id) } type="radio" name="commission_payout_detail" id="payout_detail" value='payout' className='hidden peer' />
                    <div className='peer-checked:bg-black peer-checked:text-white transition duration-300 bg-white text-gray-two flex-1 flex text-center justify-center items-center md:p-3.5 p-2 md:text-base text-sm'>Payout</div>
                </label>
            }
        </div>
    )
}

export default OptionTab